'use client';

import Image from '@/components/image';
import NextLink from '@/components/next-link';
import useCategoryStore from '@/store/category.store';
import { event_category_click } from '@/utils/gtm';
import { setCookie } from 'cookies-next';

const CategoryCard = ({
  title,
  img = '',
  link = '#',
  fromCategoriesSlider,
  imgClassName = '',
  titleClassName = '',
  target = '_self',
  fromHome,
  fromCategories,
  fromPLP,
  clickLocation,
}) => {
  const href = link?.replace(/(\/c)+/g, '/c');
  const menuTreeData = useCategoryStore((state) => state.menuTreeData);
  return (
    <NextLink
      href={href}
      onClick={() => {
        if (!href?.startsWith('/b/')) {
          event_category_click({
            menuTreeData,
            link: href,
            click_location: clickLocation,
          });
        }
        if (
          href?.startsWith('/b/') &&
          (fromCategories || fromHome || fromPLP)
        ) {
          setCookie(
            'brand_view_type',
            fromPLP ? 'category' : fromHome ? 'home-page' : 'categories-page'
          );
        }
      }}
      target={target}
      className={`flex flex-col items-center py-1 ${fromCategoriesSlider ? '' : 'gap-4'} transform transition duration-300 hover:scale-105 max-sm:gap-1`}
    >
      {img ? (
        <Image
          quality={100}
          width={140}
          height={140}
          src={img}
          className={`${fromCategoriesSlider ? 'size-32 sm:size-[132px] md:size-[136px] lg:size-[140px]' : 'size-full'} rounded-lg object-contain ${imgClassName}`}
          alt={title + 'category' || ''}
        />
      ) : (
        <div
          className={`${fromCategoriesSlider ? 'size-28 sm:size-[132px] md:size-[136px] lg:size-[140px]' : 'size-full'} rounded-lg bg-gray-300 object-contain ${imgClassName}`}
        />
      )}

      <p
        className={`${fromCategoriesSlider ? 'w-32 sm:w-[132px] md:w-[136px] lg:w-[140px]' : 'w-full'} max-sm:text-dark-300 text-center font-bold capitalize select-none max-lg:text-[15px] max-md:text-sm max-sm:text-xs md:leading-6 ${titleClassName}`}
      >
        {title}
      </p>
    </NextLink>
  );
};

export default CategoryCard;
